// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"x_sV g_jk g_fl g_fp g_fz g_dH g_t","menuItemSub":"x_sW g_dP g_fl g_fz","menuMainLink":"x_sX g_jl g_hf","menuLink":"x_sY g_jl g_hf","Link":"x_rx q_rx q_qW q_rf"};